<template>
  <div class="BotCard" >
    <div class="image">
      <img :src="image_url" width="90%"/>
    </div>
    <div class="content">
     <h2>{{name}}</h2>
      <hr/>
      <ul>

        <li>
          <!--
          This does not seem to set the URL in browser, so setting path manually instead
          <router-link :to="{name: 'Bot', params:{ bot_name: name }}">Chat with {{name}}</router-link>
          -->
          <a :href="`/bots/${name}`">Chat with {{name}}</a><br/>
        </li>
        <li v-if="related_page">
            <a :href="related_page" target="_blank">{{name}}'s Home Page</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
        name: "BotCard",
        props: ["name", 'image_url', 'id','related_page'],
        methods: {}
    }
</script>

<style scoped>
  .BotCard {
    display: grid;
    width: 90vw;
    min-height: 100px;
    max-width: 400px;
    grid-template-rows: 1fr;
    grid-template-columns: 90px 1fr;
    grid-gap: 15px;
    border: 3px solid gainsboro;
    border-radius: 1rem;
  }
  .BotCard:hover {
    background-color: gainsboro;
    border: 3px solid black;
  }
  .content {
  }
  img {
    border-radius: 50%;
  }
  a {
    text-decoration: none;
  }
  li {
    text-align: left;
  }
</style>
